module.exports = __webpack_public_path__ + "static/media/virtual.76731d10.png";